import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import { generate_unique_id } from '@Util/Utils';

import { Select_With_Autocomplete_Props } from '@Util/Types';

export default function Select_With_Autocomplete(props: Select_With_Autocomplete_Props): JSX.Element {
    const element_id: string = props.id ?? generate_unique_id();

    return (
        <div className="Form_Row">
            <Autocomplete
                disablePortal
                className={props?.className ?? ""}
                id={element_id}
                options={props.options}
                onChange={(_e, newValue: any) => props.onChange(newValue)}
                value={props.value}
                renderInput={(params) => <TextField {...params} label={props.label} variant="filled" inputProps={{
                    ...params.inputProps,
                    autoComplete: 'new-password',
                }} />}
                noOptionsText="No options"
                isOptionEqualToValue={(option, value) => option.value === value.value}
                getOptionLabel={(option) => option.label}
                disableClearable={true}
            />
        </div>
    )
}